import React from "react";
import "./../styles/nComponents/bannerComponent.css";
import { Link } from "react-router-dom";

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from "swiper/modules";

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';


// import required modules
import { Navigation, Pagination, Mousewheel, Keyboard } from 'swiper/modules';

function BannerComponent() {
  return (
    <div className="banner-section">
      <div className="shadow" />
      <Swiper
         autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        cssMode={true}
        navigation={false}
        pagination={true}
        mousewheel={true}
        keyboard={true}
        modules={[Autoplay, Navigation, Pagination, Mousewheel, Keyboard]}
        className="mySwiper banner-slider"
      >
        <SwiperSlide className="banner-slider image-1"></SwiperSlide>
        <SwiperSlide className="banner-slider image-2"></SwiperSlide>
        <SwiperSlide className="banner-slider image-3"></SwiperSlide>
        <SwiperSlide className="banner-slider image-4"></SwiperSlide>
      </Swiper>
      <div className="textaria-banner">
        <div className="text-banner-wrapper">
          <div className="banner-text-container">
            <h1 class="banner-section-heading">
              AGENCE ÉVÉNEMENTIELLE & MARKETING
            </h1>
            <p>
              Nous sommes des experts en marketing digital, en organisation
              d'événements d'entreprise et de mariages. Notre expertise inclut
              également la création de contenus publicitaires et de reportages.
              Cliquez sur "Voir le Média" pour découvrir davantage.
            </p>
          </div>
          <div className="banner-buttons-container">
            <Link to="/projects">
              <button className="project-button">Voir nos projets</button>
            </Link>
            <Link to="/services/afrijeunetv">
              <button className="rdv-button">Voir le Media</button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BannerComponent;
